export enum PictorialChartEnum {
  error = 0,
  fail,
  warning,
  success
}
